import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const aflt_masterRateCardList = (request) => {
    let ENDPOINT = '';
    ENDPOINT = URL_BASE_API+'affiliate/master-card/?column=skill_name&client_category_id='+request.data;
    return service.get(ENDPOINT);    
}; 

export const aflt_masterRateCardUpdate = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/master-card/';
  return service.post(ENDPOINT,request.data);
};

export const getAffiliateChiefBonus = (request) => {
  let affiliateId   = request.data.id;
  let ENDPOINT = URL_BASE_API+'user/chief-bonus/'+affiliateId;
  return service.get(ENDPOINT);    
}; 

export const updateAffiliateChiefBonus = (request) => {
  let affiliateId   = request.data.id;
  let ENDPOINT = URL_BASE_API+'user/chief-bonus/'+affiliateId;
  // request.data.delete("id");
  return service.put(ENDPOINT,request.data);
};

export const getRateCardChiefBonus = (request) => {
  let rateCardId   = request.data.rateCardId;
  let ENDPOINT = URL_BASE_API+'user/chief-bonus/'+rateCardId;
  return service.get(ENDPOINT);    
}; 

export const updateRateCardChiefBonus = (request) => {
  let rateCardId   = request.data.rateCardId;
  let ENDPOINT = URL_BASE_API+'user/chief-bonus/'+rateCardId;
  // request.data.delete("id");
  return service.put(ENDPOINT,request.data);
};

export const copyMasterCardToClient = (request) => {
  let from_client_categroy_id   = request.data.fromClientCategoryId;
  let client_ids   = JSON.stringify(request.data.clientIds);
  let ENDPOINT = URL_BASE_API+'affiliate/copy-master-card-to-clients/';
  // request.data.delete("id");
  return service.post(ENDPOINT,{"from_client_categroy_id":from_client_categroy_id,"to_clients":client_ids});
};

export const copyCategoryToCategory = (request) => {
  let from_client_categroy_id   = request.data.fromClientCategoryId;
  let to_client_categroy_id   = JSON.stringify(request.data.toCategoryIds);
  let ENDPOINT = URL_BASE_API+'affiliate/copy-category-to-category/';
  return service.post(ENDPOINT,{"from_category_id":from_client_categroy_id,"to_category_id":to_client_categroy_id});
};

export const rateCardList = (request) => { 
  let ENDPOINT = URL_BASE_API+'affiliate/master-card/?column=skill_name&rate_crad_id='+request.data;
  return service.get(ENDPOINT);    
}; 

export const rateCardUpdate = (request) => {
const ENDPOINT = URL_BASE_API+'affiliate/master-card/';
return service.post(ENDPOINT,request.data);
};

